import createReactClass from "create-react-class";

export default function() {
    const html = createReactClass({
        render() {
            return null;
        },
        componentWillReceiveProps(props) {
            this.callHandler(props);
        },
        componentWillMount() {
            this.callHandler();
        },
        callHandler(props = this.props) {
            var {field, globalState} = props;
            var {setValue} = field.config.handlers;
            setValue.bind(this)(field, globalState);
        }
    });

    return {
        html,
        config: {
            invisible: true,
        },
    };
};


